import TooltipWrapper from '@/components/UI/New/TooltipWrapper/TooltipWrapper'
import classNames from 'classnames'
import { createContext, FC, useContext, useEffect, useState } from 'react'
import classes from './index.module.css'

export const PlatformSupportContext = createContext<{
  open: boolean
  unread: number
  toggle: () => void
} | null>(null)

interface Props {
  className?: string
  sidebar?: boolean
  isMinimizedMenu?: boolean
}

const PlatformSupportLauncher: FC<Props> = ({ className, sidebar = false, isMinimizedMenu = false }) => {
  const support = useContext(PlatformSupportContext)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const tooltipEnabled = Boolean(support && !support.open && (!sidebar || isMinimizedMenu))
  useEffect(() => { if (!tooltipEnabled) setTooltipOpen(false) }, [tooltipEnabled])
  if (!support) return null

  return (
    <TooltipWrapper
      title="Техподдержка"
      open={tooltipEnabled && tooltipOpen}
      onOpenChange={(next) => setTooltipOpen(tooltipEnabled && next)}
      destroyTooltipOnHide
      placement={sidebar ? 'right' : 'top'}
      trigger={['hover', 'focus']}
      mouseEnterDelay={0.15}
    >
      <button
        type="button"
        className={classNames(sidebar ? classes.sidebarLauncher : classes.launcher, className, {
          [classes.launcherActive]: support.open,
          [classes.sidebarLauncherMinimized]: sidebar && isMinimizedMenu,
        })}
        onClick={() => { setTooltipOpen(false); support.toggle() }}
        onMouseLeave={() => setTooltipOpen(false)}
        onBlur={() => setTooltipOpen(false)}
        aria-label={support.unread ? `Техподдержка: новых ответов ${support.unread}` : 'Техподдержка'}
        aria-expanded={support.open}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="3.6" />
          <path d="m5.6 5.6 3.9 3.9M14.5 14.5l3.9 3.9M18.4 5.6l-3.9 3.9M9.5 14.5l-3.9 3.9" />
        </svg>
        {sidebar && !isMinimizedMenu && <span>Техподдержка</span>}
        {support.unread > 0 && <span className={classes.badge}>{support.unread > 9 ? '9+' : support.unread}</span>}
      </button>
    </TooltipWrapper>
  )
}

export default PlatformSupportLauncher
